// extracted by mini-css-extract-plugin
export default {"kv":"Base_kv__1IrAb","bg":"Base_bg__BZWXU","black":"Base_black__M3SaS"};